import { FC, useMemo } from 'react';
import { useRecoilValue } from 'recoil';

import { useToastState } from '@/context';

import { ToastsList } from './styled';
import { Toast as ToastComponent } from './toast';

export const Toasts: FC = () => {
  const toasts = useRecoilValue(useToastState);

  const list = useMemo(
    () =>
      toasts.map(({ id, title, description, type }) => (
        <ToastComponent key={id} id={id} title={title} description={description} type={type} />
      )),
    [toasts]
  );

  if (!toasts.length) return null;

  return <ToastsList data-testid="toasts-container">{list}</ToastsList>;
};
